
export default function useDraggableScroll(ref, direction = 'both') {




    // A posição inicial (progresso de rolagem e localização do mouse)
    // quando o mouse é pressionado no elemento
    let initialPosition = { scrollTop: 0, scrollLeft: 0, mouseX: 0, mouseY: 0 };

    //Ao movimentar
    const mouseMoveHandler = (e) => {
        if (ref.current) {
            // Calcula as diferenças para ver o quanto o usuário se moveu
            const dx = e.clientX - initialPosition.mouseX;
            const dy = e.clientY - initialPosition.mouseY;

            if (direction !== 'horizontal')
                ref.current.scrollTop = initialPosition.scrollTop - dy;
            if (direction !== 'vertical')
                ref.current.scrollLeft = initialPosition.scrollLeft - dx;

        }

    }

    //Ao Soltar
    const mouseUpHandler = () => {
        // Retorno ao cursor: pega depois que o usuário não está mais pressionando
        if (ref.current) ref.current.style.cursor = 'grab';

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    }
    //Ao segurar(grab)
    const onMouseDown = (e) => {
        if (ref.current) {
            // Salva a posição no momento em que o usuário pressiona
            initialPosition = {
                scrollLeft: ref.current.scrollLeft,
                scrollTop: ref.current.scrollTop,
                mouseX: e.clientX,
                mouseY: e.clientY,

            }

            ref.current.style.cursor = 'grabbing';
            ref.current.style.userSelect = 'none'


            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);

        }

    }

    return { onMouseDown }

}


